import type { ChainId } from '@morpho-org/blue-sdk'

import { ChainConfig } from '@/config'

/**
 * `?chains=` is unvalidated URL input, so ids the app does not serve are dropped before
 * they reach either the API or the filter UI.
 */
export function sanitizeVaultsChainIds(chains: number[]): ChainId[] {
  return chains.filter(ChainConfig.isAvailable)
}

/**
 * The `chainIds` the vaults API is asked for. The API rejects any chain it does not
 * serve, and an all-unsupported list falls back to every available chain, like no
 * filter at all.
 */
export function resolveVaultsChainIds(chains: number[]): ChainId[] {
  const availableChains = sanitizeVaultsChainIds(chains)
  return availableChains.length > 0 ? availableChains : ChainConfig.AVAILABLE_CHAIN_IDS
}
